import { Context, useContext } from 'react';

import { fragmentContext } from '../../../shared/fragmentContext';

export const useFragmentContext = <T>(): T => {
    return useContext<T>(fragmentContext as unknown as Context<T>);
};
